/**
 * Site Search
 */
import * as basicLightbox from 'basiclightbox';
import { breakpoints } from './variables';
// import { disableScroll, enableScroll } from '../global/helpers';

const isMobileMenu = breakpoints.isMobileMenu();

class SiteSearch {
	constructor(form, useLightbox) {
		if (typeof form === 'undefined' || form === null) {
			return;
		}

		this.form = form;
		this.formTextField = this.form.querySelector('input[type="text"]');
		this.formSiteSearch = this.form.querySelector('input[data-value="site"]');
		this.scopeRadios = this.form.querySelectorAll('input[name="search-scope"]');
		this.showFormHandler = this.showFormHandler.bind(this);
		this.opener = document.getElementById('search-trigger');
		this.useLightbox = useLightbox;

		if (!isMobileMenu) {
			this.lightbox = basicLightbox.create(document.querySelector('.site-header .search-form-wrapper'), {
				onShow: (instance) => {
					// Close when hitting escape.
					document.onkeydown = function (evt) {
						evt = evt || window.event;
						let isEscape = false;
						if ('key' in evt) {
							isEscape = (evt.key === 'Escape' || evt.key === 'Esc');
						} else {
							isEscape = (evt.keyCode === 27);
						}
						if (isEscape) {
							instance.close();
						}
					};
				},
			});
		}
		this.init();
	}

	/**
	 * Method to show the search form.
	 */
	showFormHandler(e) {
		if (this.useLightbox && !isMobileMenu) {
			const {
				formTextField, lightbox, formSiteSearch,
			} = this;

			if (!lightbox.visible()) {
				e.preventDefault();

				lightbox.show();

				setTimeout(() => {
					formTextField.focus();
					formSiteSearch.click();
				}, 100);
			}
		}
		return false;
	}

	searchScopeHandler() {
		// I'd pull out formTextField here, but it's always undefined for some reason?
		const form = this.closest('form');
		const scopes = {
			site: {
				action: 'https://nanostring.com/',
				queryvar: 's',
			},
			university: {
				action: 'https://university.nanostring.com/',
				queryvar: 'q',
			},
			publications: {
				action: 'https://nanostring.com/resources/publications/',
				queryvar: 'search',
			},
		};
		const chosenScope = form.querySelector('input[name="search-scope"]:checked').dataset.value;
		form.action = scopes[chosenScope].action;
		form.querySelector('input[type="text"]').name = scopes[chosenScope].queryvar;
	}

	/**
	 * Core method to set display of search method.
	 */
	init() {
		const { opener, scopeRadios } = this;
		const searchScoper = this.searchScopeHandler;

		// Listen for clicks on the opener.
		opener.addEventListener('click', this.showFormHandler, false);

		// Listen for search scope changes.
		scopeRadios.forEach((radio) => radio.addEventListener('change', searchScoper, false));

		return true;
	}
}

const siteMenuSearch = {
	init() {
		const navSearchForm = document.getElementsByTagName('header')[0].querySelector('.search-form');
		const resultSearchForm = document.querySelector('.em-filterable-content__filter-container .search-form');

		// eslint-disable-next-line no-new
		new SiteSearch(navSearchForm, true);
		// eslint-disable-next-line no-new
		new SiteSearch(resultSearchForm, false);
	},
};

siteMenuSearch.init();
